import feathers from 'feathers-client';
// import socketio from '@feathersjs/socketio-client';
// import io from 'socket.io-client';
import config from './config/config.json';

const host = config.production.host;

// const socket = io(host); // Usa Socket.io

export default feathers()
    .configure(feathers.hooks())
    // .configure(socketio(socket))
    .configure(feathers.rest(host).fetch(window.fetch.bind(window)))
    .configure(feathers.authentication({ jwtStrategy: 'jwt', storage: window.localStorage }));
